import { render, staticRenderFns } from "./BalanceIn.vue?vue&type=template&id=0a2ecaec&scoped=true"
import script from "./BalanceIn.vue?vue&type=script&lang=js"
export * from "./BalanceIn.vue?vue&type=script&lang=js"
import style0 from "./BalanceIn.vue?vue&type=style&index=0&id=0a2ecaec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2ecaec",
  null
  
)

export default component.exports